import RatesContainerBlock from './RatesContainerBlock'
import RatesTableBlock from './RatesTableBlock'

export { RatesContainerBlock, RatesTableBlock }
